<template>
    <TxRendererScreenshotArea>
        <HtmlTemplate/>
        <HtmlTemplateTitle/>
    </TxRendererScreenshotArea>
</template>

<script>
    import HtmlTemplate from './HtmlTemplate'
    import HtmlTemplateTitle from './HtmlTemplateTitle'
    import HtmlTemplateModule from "../store-mixin";

    export default {
        name: 'HtmlTemplateProduct',
        mixins: [HtmlTemplateModule()],
        components: {
            HtmlTemplate,
            HtmlTemplateTitle,
        },
    }
</script>

<style scoped lang="scss">

</style>

